import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import Spacer from './Spacer';

const Container = styled.div`
  position: relative;
`;

const SelectedItem = styled.div`
  background: white;
  border-radius: 10px;
  padding: 8px 17px;
  box-shadow: 0px 2px 13px #2f2c7e0d;
  color: #d6d8de;
  font-size: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const ItemValue = styled.div`
  color: #5d6ef8;
  font-size: 13px;
  font-weight: 600;
`;

const ItemDescription = styled.div`
  font-size: 11px;
  font-weight: 500;
  color: #d6d8de;
`;

const Dropdown = styled.div`
  background: white;
  border-radius: 10px;
  padding: 8px 0px;
  box-shadow: 0px 2px 13px #2f2c7e0d;
  color: #5d6ef8;
  font-size: 12px;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 6px;
  width: 100%;
  position: absolute;
  z-index: 100;
`;

const DropdownItem = styled.div`
  font-weight: 600;
  font-size: 13px;
  padding: 8px;
  width: 100%;
  text-align: center;
  transition: all 0.2s;
  cursor: pointer;
  &:hover {
    background: #f8f9fe;
  }
`;

type Props = {
  items: Item[];
  defaultItem: number;
  onChange?: (amount: number) => void;
};

type Item = {
  value: number;
  label: string;
};

export default function FancyDropdown({ onChange, items, defaultItem }: Props) {
  const [dropped, setDropped] = React.useState(false);

  const [selected, setSelected] = React.useState(items[defaultItem]);
  const containerRef: any = React.useRef(null);
  return (
    <Container
      onFocus={() => setDropped(true)}
      onBlur={() => setDropped(false)}
      ref={containerRef}
      tabIndex={0}
    >
      <SelectedItem>
        <ItemValue>{selected.label}</ItemValue>
        <Spacer horizontal spacing={1} />
        <ItemDescription>REQUESTS</ItemDescription>
        <Spacer horizontal spacing={1} />
        <FontAwesomeIcon icon={faChevronDown} />
      </SelectedItem>
      {dropped && (
        <Dropdown>
          {items
            .filter((val) => val.value !== selected.value)
            .map((val) => (
              <DropdownItem
                onClick={() => {
                  setSelected(val);
                  if (onChange) {
                    onChange(val.value);
                  }
                  if (containerRef.current) containerRef.current.blur();
                }}
              >
                {val.label}
              </DropdownItem>
            ))}
        </Dropdown>
      )}
    </Container>
  );
}
